import BaseModel from './base';

class InvoiceModel extends BaseModel {
	async getDownload(invoiceId) {
		const result = await this.get(`/download/${invoiceId}`, {
			completeResponse: true
		});

		return result;
	}

	async regenerate(invoiceId) {
		await this.post(`/files/${invoiceId}/regenerate`);
	}
}

export default new InvoiceModel('/invoice');
